export default class Geocoding {
  /**
   * @param {string} address
   * @return {Promise<any>}
   * @see https://wiki.openstreetmap.org/wiki/FR:Nominatim
   */
  static geocodeAddress(address) {
    return fetch(
      `http://nominatim.openstreetmap.org/search?format=json&limit=1&q=${address}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          const { lat: latitude, lon: longitude } = data[0];

          return { latitude, longitude };
        }

        return null;
      })
      .catch(window.console.error);
  }
}
